





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import DataGrid from '@/components/reusable/datagrid/DataGrid.vue';
import IDataGrid from '@/components/reusable/datagrid/IDataGrid';
import DataGridOptions from '@/components/reusable/datagrid/DataGridOptions';

import CompanyEdit from '@/components/administration/companies/CompanyEdit.vue';

interface ISearchTerms {
    Name: string;
    Active: boolean;
}

@Component({
    components: {
        DataGrid,
        CompanyEdit
    }
})
export default class Companies extends Vue {
    private GridOptions: DataGridOptions;
    private SearchTerms: ISearchTerms ;
    private SelectedId: number = 0;

    constructor() {
        super();
        this.GridOptions = new DataGridOptions();
        this.GridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.companyGetList;
        this.GridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.companyDelete;
        this.GridOptions.HasDelete = true;
        this.GridOptions.RowSelection = true;
        this.GridOptions.UrlRouting = '/admin/companydetails/';
        this.SearchTerms = { Name: '', Active: true };
        this.GridOptions.VirtualScrolling = false;
        this.GridOptions.Styles.Table = ['gridcontainer'];
        this.GridOptions.Styles.Header = ['gridheader'];
        this.GridOptions.Styles.Cell = ['gridcell'];
        this.GridOptions.Columns = [
            { Title: 'Id', FieldName: 'Id', Visible: false },
            { Title: 'Company Name', FieldName: 'Name', Visible: true },
            { Title: 'Active', FieldName: 'Active', Visible: true },
            { Title: 'LastUpdate', FieldName: 'DateUpdated', Visible: true }
        ];
    }

    private Search() {
        (this.$refs.dataGrid as unknown as IDataGrid).Search(this.SearchTerms);
    }

    private Clear() {
        this.SearchTerms.Name = '';
        this.SearchTerms.Active = true;

        (this.$refs.dataGrid as unknown as IDataGrid).Reload(true);
    }

    private Refresh() {
        (this.$refs.dataGrid as unknown as IDataGrid).Reload(true);
    }

    private ShowEditForm(id: number) {
        this.SelectedId = id;
        this.$bvModal.show('modal-edit');
    }

    private CloseEditForm() {
        this.$bvModal.hide('modal-edit');
    }

    private OnChangesSaved() {
        this.$bvToast.toast('Changes were saved successfully.',
            {
                variant: 'warning',
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000
            });

        this.Refresh();
    }
    private OnDeleteFinished() {
        this.$bvToast.toast('Company deleted successfully.',
            {
                variant: 'success',
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000
            });
    }
}
